import { useMutation, useQueryClient } from 'react-query'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'
import { QUERY_KEYS } from 'src/constants'
import { accountsService } from 'src/services/accounts.service'

import { IAccountByIdRespDto } from 'src/types'

export const useUpdateAccountPublicStatus = (locale?: string) => {
  const queryClient = useQueryClient()

  return useMutation(
    async (dto: { id: string; public: boolean }) =>
      accountsService.updateAccountPublicStatus(dto.id, { public: dto.public }),
    {
      onSuccess: (_, vars) => {
        queryClient.setQueriesData(
          [QUERY_KEYS.ACCOUNT, vars.id, locale ?? DEFAULT_LANGUAGE_CODE],
          (prev?: IAccountByIdRespDto) => {
            return prev
              ? { ...prev, public: vars.public }
              : (undefined as unknown as IAccountByIdRespDto)
          },
        )
        queryClient.invalidateQueries([QUERY_KEYS.ACCOUNTS])
      },
    },
  )
}
